// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1tGg4","footer":"ModalError_footer__2x32u"};